/*
  app icon
*/
import backup from '@/assets/images/app/backup.png';
import browser from '@/assets/images/app/browser.png';
import calculator from '@/assets/images/app/calculator.png';
import call_history from '@/assets/images/app/call_history.png';
import call from '@/assets/images/app/call.png';
import camera from '@/assets/images/app/camera.png';
import conference from '@/assets/images/app/conference.png';
import contacts from '@/assets/images/app/contacts.png';
import filemanager from '@/assets/images/app/filemanager.png';
import ftpserver from '@/assets/images/app/ftpserver.png';
import gs_market from '@/assets/images/app/gs_market.png';
import messages from '@/assets/images/app/messages.png';
import mpk from '@/assets/images/app/mpk.png';
import presentation from '@/assets/images/app/presentation.png';
import recorder from '@/assets/images/app/recorder.png';
import settings from '@/assets/images/app/settings.png';
import statedetection from '@/assets/images/app/statedetection.png';
import voicemail from '@/assets/images/app/voicemail.png';
import xmpp from '@/assets/images/app/xmpp.png';
import xsi from '@/assets/images/app/xsi.png';
import guildlines from '@/assets/images/app/guildlines.png';
import wireless_mic from '@/assets/images/app/wireless_mic.png';
import hwcontacts from '@/assets/images/app/hwcontacts.png';
import schedule from '@/assets/images/app/schedule.png';
import clock from '@/assets/images/app/clock.png';
import conf_ctrl from '@/assets/images/app/conf_control.png';
import oneclick from '@/assets/images/app/oneclick.png';
import ldap from '@/assets/images/app/ldap.png';
import call_center from '@/assets/images/app/call_center.png';

/**
 * app icon transparent
 */
import backup_tr from '@/assets/images/app/backup_transparent.png';
import browser_tr from '@/assets/images/app/browser_transparent.png';
import calculator_tr from '@/assets/images/app/calculator_transparent.png';
import call_history_tr from '@/assets/images/app/call_history_transparent.png';
import call_tr from '@/assets/images/app/call_transparent.png';
import camera_tr from '@/assets/images/app/camera_transparent.png';
import conference_tr from '@/assets/images/app/conference_transparent.png';
import contacts_tr from '@/assets/images/app/contacts_transparent.png';
import filemanager_tr from '@/assets/images/app/filemanager_transparent.png';
import ftpserver_tr from '@/assets/images/app/ftpserver_transparent.png';
import gs_market_tr from '@/assets/images/app/gs_market_transparent.png';
import messages_tr from '@/assets/images/app/messages_transparent.png';
import mpk_tr from '@/assets/images/app/mpk_transparent.png';
import presentation_tr from '@/assets/images/app/presentation_transparent.png';
import recorder_tr from '@/assets/images/app/recorder_transparent.png';
import settings_tr from '@/assets/images/app/settings_transparent.png';
import statedetection_tr from '@/assets/images/app/statedetection_transparent.png';
import voicemail_tr from '@/assets/images/app/voicemail_transparent.png';
import xmpp_tr from '@/assets/images/app/xmpp_transparent.png';
import xsi_tr from '@/assets/images/app/xsi_transparent.png';
import guildlines_tr from '@/assets/images/app/guildlines_transparent.png';
import wireless_mic_tr from '@/assets/images/app/wireless_mic_transparent.png';
import hwcontacts_tr from '@/assets/images/app/hwcontacts_transparent.svg';
import schedule_tr from '@/assets/images/app/schedule_transparent.svg';
import clock_tr from '@/assets/images/app/clock_transparent.svg';
import conf_ctrl_tr from '@/assets/images/app/conf_control_transparent.png';
import oneclick_tr from '@/assets/images/app/oneclick_transparent.png';
import ldap_tr from '@/assets/images/app/ldap_transparent.png';
import call_center_tr from '@/assets/images/app/call_center_transparent.png';

const APP_ITEMS = {
  // app
  // 备份和恢复
  'com.base.module.backup.ui.activity.MainActivity': {
    className: 'com.base.module.backup.ui.activity.MainActivity',
    packageName: 'com.base.module.backup',
    apkName: 'Backup',
    img: backup,
    imgTr: backup_tr,
    title: 'BACKUP',
  },
  // 浏览器
  'com.android.browser.BrowserActivity': {
    className: 'com.android.browser.BrowserActivity',
    packageName: 'com.android.browser',
    apkName: 'Browser',
    img: browser,
    imgTr: browser_tr,
    title: 'BROWSER',
  },
  // 计算器
  'com.android.calculator2.Calculator': {
    className: 'com.android.calculator2.Calculator',
    packageName: 'com.android.calculator2',
    apkName: 'Calculator',
    img: calculator,
    imgTr: calculator_tr,
    title: 'CALCULATOR',
  },
  // 通话记录
  'com.base.module.callhistory.CallHistoryActivity': {
    className: 'com.base.module.callhistory.CallHistoryActivity',
    packageName: 'com.base.module.callhistory',
    apkName: 'Call History',
    img: call_history,
    imgTr: call_history_tr,
    title: 'CALLHISTORY',
  },
  // 相机
  'com.android.camera.CameraLauncher': {
    className: 'com.android.camera.CameraLauncher',
    packageName: 'com.android.camera2',
    apkName: 'Camera',
    img: camera,
    imgTr: camera_tr,
    title: 'CAMERA',
  },
  // 会议室
  'com.base.module.phone.view.activity.SwitchToConfView': {
    className: 'com.base.module.phone.view.activity.SwitchToConfView',
    packageName: 'com.base.module.phone',
    apkName: 'Conf',
    img: conference,
    imgTr: conference_tr,
    title: 'CONFERENCE',
  },
  // 联系人
  'com.android.contacts.activities.MainActivity': {
    className: 'com.android.contacts.activities.MainActivity',
    packageName: 'com.android.contacts',
    apkName: 'Contacts',
    img: contacts,
    imgTr: contacts_tr,
    title: 'CONTACTS',
  },
  // 文件管理器
  'com.base.module.filemanager.activity.MainActivity': {
    className: 'com.base.module.filemanager.activity.MainActivity',
    packageName: 'com.base.module.filemanager',
    apkName: 'FileManager',
    img: filemanager,
    imgTr: filemanager_tr,
    title: 'FILEMANAGER',
  },
  // 文件传输服务
  'com.base.module.control.ServerControlActivity': {
    className: 'com.base.module.control.ServerControlActivity',
    packageName: 'com.base.module.control',
    apkName: 'FTP',
    img: ftpserver,
    imgTr: ftpserver_tr,
    title: 'FTP_SERVER',
  },
  // GS 应用市场
  'com.base.module.market.main.Gs33XXMainActivity': {
    className: 'com.base.module.market.main.Gs33XXMainActivity',
    packageName: 'com.base.module.market',
    apkName: 'GS Market',
    img: gs_market,
    imgTr: gs_market_tr,
    title: 'MARKET',
  },
  // 短信
  'com.base.module.message.activity.MainActivity': {
    className: 'com.base.module.message.activity.MainActivity',
    packageName: 'com.base.module.message',
    apkName: 'GsMessage',
    img: messages,
    imgTr: messages_tr,
    title: 'MESSAGE',
  },
  // 可编程键
  'com.base.module.mpk.ui.activity.MainActivity': {
    className: 'com.base.module.mpk.ui.activity.MainActivity',
    packageName: 'com.base.module.mpk',
    apkName: 'MPK',
    img: mpk,
    imgTr: mpk_tr,
    title: 'MPK',
  },
  // 电话
  'com.base.module.phone.view.activity.DialMainActivity': {
    className: 'com.base.module.phone.view.activity.DialMainActivity',
    packageName: 'com.base.module.phone',
    apkName: 'Phone',
    img: call,
    imgTr: call_tr,
    title: 'PHONE',
  },
  // 演示
  'com.base.module.presentation.PresentationActivity': {
    className: 'com.base.module.presentation.PresentationActivity',
    packageName: 'com.base.module.presentation',
    apkName: 'Presentation',
    img: presentation,
    imgTr: presentation_tr,
    title: 'PRESENTATION',
  },
  // 录音管理
  'com.base.module.recordingmanagement.ui.FirstActivity': {
    className: 'com.base.module.recordingmanagement.ui.FirstActivity',
    packageName: 'com.base.module.recordingmanagement',
    apkName: 'Recorder',
    img: recorder,
    imgTr: recorder_tr,
    title: 'RECORDER',
  },
  // 设置
  'com.android.settings.gs.activity.SettingsActivity': {
    className: 'com.android.settings.gs.activity.SettingsActivity',
    packageName: 'com.android.settings',
    apkName: 'Settings',
    img: settings,
    imgTr: settings_tr,
    title: 'SETTINGS',
  },
  // 状态检测
  'com.base.module.statedetection.MainActivity': {
    className: 'com.base.module.statedetection.MainActivity',
    packageName: 'com.base.module.statedetection',
    apkName: 'State Detection',
    img: statedetection,
    imgTr: statedetection_tr,
    title: 'STATE_DETECTION',
  },
  // 语言邮件
  'com.base.module.voicemail.VMActivity': {
    className: 'com.base.module.voicemail.VMActivity',
    packageName: 'com.base.module.voicemail',
    apkName: 'Voice Mail',
    img: voicemail,
    imgTr: voicemail_tr,
    title: 'VOICEMAIL',
  },
  // BS-IM&P
  'com.base.module.broadsoft.xmpp.ui.activity.LoginActivity': {
    className: 'com.base.module.broadsoft.xmpp.ui.activity.LoginActivity',
    packageName: 'com.base.module.broadsoft.xmpp',
    apkName: 'BroadsoftXmpp',
    img: xmpp,
    imgTr: xmpp_tr,
    title: 'XMPP',
  },
  // BS XSI
  'com.base.module.broadsoft.xsi.view.LoginActivity': {
    className: 'com.base.module.broadsoft.xsi.view.LoginActivity',
    packageName: 'com.base.module.broadsoft.xsi.view',
    apkName: 'Xsi',
    img: xsi,
    imgTr: xsi_tr,
    title: 'XSI',
  },
  // 无线麦克风
  'com.grandstream.gmd.ui.WirelessMicActivity': {
    className: 'com.grandstream.gmd.ui.WirelessMicActivity',
    packageName: 'com.grandstream.gmd',
    apkName: 'GmdSettings',
    img: wireless_mic,
    imgTr: wireless_mic_tr,
    title: 'WIRELESS_MIC',
  },
  // 使用指南
  'com.android.settings.GuildLinesActivity': {
    className: 'com.android.settings.GuildLinesActivity',
    packageName: 'com.android.settings',
    apkName: 'Guidelines',
    img: guildlines,
    imgTr: guildlines_tr,
    title: 'GUILDLINES',
  },

  // 预约会议
  'com.base.module.schedule.view.activity.MainActivity': {
    className: 'com.base.module.schedule.view.activity.MainActivity',
    packageName: 'com.base.module.schedule',
    apkName: 'Schedule',
    img: schedule,
    imgTr: schedule_tr,
    title: 'SCHEDULE',
  },
  // 企业通讯录
  'com.gs.hwcontacts.ui.main.MainActivity': {
    className: 'com.gs.hwcontacts.ui.main.MainActivity',
    packageName: 'com.gs.hwcontacts',
    apkName: 'HwContacts',
    img: hwcontacts,
    imgTr: hwcontacts_tr,
    title: 'ENTERPRISE_DIR',
  },

  // 闹钟
  'com.android.deskclock.DeskClock': {
    className: 'com.android.deskclock.DeskClock',
    packageName: 'com.android.deskclock',
    apkName: 'DeskClock',
    img: clock,
    imgTr: clock_tr,
    title: 'CLOCK_APP',
  },

  // 会控
  'com.base.module.conferencecontroller.ui.activity.MainActivity': {
    className: 'com.base.module.conferencecontroller.ui.activity.MainActivity',
    packageName: 'com.base.module.conferencecontroller',
    apkName: 'ConferenceController',
    img: conf_ctrl,
    imgTr: conf_ctrl_tr,
    title: 'CONF_CONTROL',
  },

  // 一键配置
  'com.android.settings.gs.advanced.upgrade.ProfileCodeActivity': {
    className: 'com.android.settings.gs.advanced.upgrade.ProfileCodeActivity',
    packageName: 'com.android.settings',
    apkName: 'OneClickConfig',
    img: oneclick,
    imgTr: oneclick_tr,
    title: 'ONE_CLICK_CONFIG',
  },

  // LDAP
  'com.android.contacts.LDAPActivity': {
    className: 'com.android.contacts.LDAPActivity',
    packageName: 'com.android.contacts',
    apkName: 'LDAP',
    img: ldap,
    imgTr: ldap_tr,
    title: 'LDAP',
  },

  // Call Center
  'com.base.module.phone.view.activity.CallCenterActivity': {
    className: 'com.base.module.phone.view.activity.CallCenterActivity',
    packageName: 'com.base.module.phone',
    apkName: 'Call Center',
    img: call_center,
    imgTr: call_center_tr,
    title: 'CALL_CENTER',
  },
};

export default APP_ITEMS;
